"use client"
import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr"
import 'flatpickr/dist/flatpickr.min.css';

const DatePicker =  {
    init: function(){
        flatpickr(".input__date", {
            disableMobile: true, // to use plugin on mobile, non native input date
            dateFormat: "d/m/Y",
            minDate: "today",
            maxDate: new Date().fp_incr(59),
            locale: French
        });
    }
}

export default DatePicker;